import './init';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import './app.scss'; 

// Import from the new location
import configureStore from './App/store'; 
import { history } from '@/utils/history'; 

// --- TRACER INJECTION ---
import { enableReactTracing } from './utils/reactTracer';
import { initializeGeoCookie } from '@/utils/analytics';
enableReactTracing();
// ------------------------

// Fetch anonymous location if they skipped Marketing site
initializeGeoCookie();

// Initialize the store singleton before rendering
configureStore({}, history);

const rootElement = document.getElementById('root') || document.getElementById('app');

// =========================================================================
// AUTOMATED VERSION BUMPER (ATS)
// Uses a unique timestamp injected by the build server (CircleCI/Docker).
// Falls back to '1.0.0' if running locally in development.
// =========================================================================
const APP_VERSION = process.env.REACT_APP_BUILD_ID || '1.0.0'; 
const storedVersion = localStorage.getItem('NOVIOPUS_ATS_VERSION');

if (storedVersion !== APP_VERSION) {
  console.log(`[Version Bumper] Upgrading to build ${APP_VERSION}. Clearing stale cache...`);
  
  localStorage.clear();
  sessionStorage.clear();
  localStorage.setItem('NOVIOPUS_ATS_VERSION', APP_VERSION);
  
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  }
  
  window.location.reload();
} else {
  if (!rootElement) {
    console.error("Critical: Root element not found");
  } else {
    // React 16 Render
    ReactDOM.render(<App />, rootElement);
  }
}